import React from "react";
import { Menu } from 'antd';
import { Link } from "react-router-dom";
import './menuc.css';

const MenuPortal = ({active}) => {

  const { SubMenu } = Menu;

  let state = {
    current: active,
  };

  const handleClick = e => {
    console.log('click ', e);
    state = {
      current: e.key,
    };
    console.log(state);
  };

  return (
    <>
      <Menu onClick={handleClick} 
            selectedKeys={[state.current]} 
            mode="horizontal" 
            className="menuPortalObs" >

        <Menu.SubMenu key="acercade" 
                      title={
                          <a href="/portal/observador" >
                            <span onclick="hide()">Acerca de</span>
                          </a>
                      } >

            <Menu.Item className="menuPortalObs-sub-menu menuPortalObs-sub-menu-1" key="acercade:1" >
              <Link to={"/portal/observador#a1"} onClick={() => window.location= "/portal/observador#a1"} rel="noopener noreferrer">
                Conoce más
              </Link>
            </Menu.Item>

            <Menu.Item className="menuPortalObs-sub-menu" key="acercade:2">
              <Link to={"/portal/observador#a2"} onClick={() =>  window.location= "/portal/observador#a2"} rel="noopener noreferrer">
                Derechos y obligaciones
              </Link>
            </Menu.Item>

            <Menu.Item className="menuPortalObs-sub-menu" key="acercade:3">
              <Link to={"/portal/observador#a3"} onClick={() => window.location= "/portal/observador#a3"} rel="noopener noreferrer">
                Conviértete en Observador/a
              </Link>
            </Menu.Item>

        </Menu.SubMenu>

        <Menu.Item key="requisitos">
          <Link to={"/portal/requisitos"} rel="noopener noreferrer">
            Requisitos
          </Link>
        </Menu.Item>

        <Menu.Item key="documentos">
          <Link to={"/portal/documentos"} rel="noopener noreferrer">
            Documentos
          </Link>
        </Menu.Item>

        <SubMenu key="solicitudes"
                popupClassName="mnu-nav-new-sm"
                title={  
                  <a href="/portal/solicitud">
                    <span className="submenu-title-wrapper sol" onclick="hide()">Solicitud</span>
                  </a>
                } >
        
            <Menu.Item className="menuPortalObs-sub-menu menuPortalObs-sub-menu-1" key="solicitud:1">
              <Link to={"/portal/solicitud#a1"} onClick={() => window.location= "/portal/solicitud#a1"} rel="noopener noreferrer">
                Registro de solicitud de la ciudadanía
              </Link>
            </Menu.Item>

            <Menu.Item className="menuPortalObs-sub-menu" key="solicitud:2">
              <Link to={"/portal/solicitud#a2"} onClick={() =>  window.location= "/portal/solicitud#a2"} rel="noopener noreferrer">
                Registro de solicitud de la ciudadanía que pertenece a una organización
              </Link>
            </Menu.Item>

            <Menu.Item className="menuPortalObs-sub-menu" key="solicitud:3">
              <Link to={"/portal/solicitud#a3"} onClick={() => window.location= "/portal/solicitud#a3"} rel="noopener noreferrer">
                Registro de solicitud de las organizaciones
              </Link>
            </Menu.Item>
        </SubMenu>

        <Menu.Item key="acreditacion">
          <Link to={"/portal/acreditacion"} rel="noopener noreferrer">
            Acreditación
          </Link>
        </Menu.Item>
        
    </Menu>
  </>
  );
};

export default MenuPortal;